@if (data(); as data) {
  <div class="flex flex-col rounded-md bg-gray-50 p-16">
    <div class="mb-6 text-3xl font-bold text-gray-600">
      Otrzymaliśmy Twoje zamówienie!
    </div>

    <div class="grid gap-3 text-sm text-gray-500 xl:grid-cols-2">
      <div class="flex flex-col flex-wrap gap-6">
        <div>
          <div class="flex flex-wrap">
            <span class="mr-1">Status zamówienia:</span>
            <span class="font-bold">
              {{ data.status | orderStatus | async }}
            </span>
          </div>

          <div class="flex flex-wrap">
            <span class="mr-1">Numer zamówienia:</span>
            <span class="font-bold">{{ data.number }}</span>
          </div>

          <div class="flex flex-wrap">
            <span class="mr-1">Całkowita wartość zamówienia:</span>
            <span class="font-bold">
              <app-currency [amount]="data.totalPrice" />
            </span>
          </div>

          <div class="flex flex-wrap">
            <span class="mr-1">Rodzaj płatności:</span>
            <span class="font-bold">
              {{ data.paymentMethod.name }}
            </span>
          </div>
        </div>

        <div class="flex flex-col flex-wrap">
          Po zaksięgowaniu płatności przystąpimy do realizacji zamówienia.
          <br />
          O kolejnych etapach będziemy niezwłocznie powiadamiać Cię drogą
          mailową.
        </div>
      </div>

      <div class="col-span-2 mt-6 flex justify-center text-base">
        <app-router-link
          [route]="Route.Root"
          [contents]="true">
          <app-slim-button
            [fluid]="true"
            maxWidth="16rem"
            label="Powrót do sklepu"
            theme="primary" />
        </app-router-link>
      </div>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
